import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  /**
   * Exporta la lista de errores a un archivo Excel.
   * @param response La respuesta JSON completa que contiene la propiedad 'errors'.
   * @param fileName Nombre base del archivo a generar.
   */
  public exportErrorsToExcel(response: any, fileName: string): void {
    // 1. Extraer el array de errores
    const errorsData: any[] = response.errors || [];

    if (errorsData.length === 0) {
      return;
    }

    // 2. Convertir el array de JSON (errorsData) a hoja de cálculo
    // La función json_to_sheet usa automáticamente las claves (row, field, message) como encabezados.
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(errorsData);

    // Opcional: Si quieres nombres de encabezado más amigables (ej: "Fila" en lugar de "row")
    // XLSX.utils.sheet_add_aoa(worksheet, [["Fila", "Campo", "Mensaje"]], { origin: "A1" });

    const workbook: XLSX.WorkBook = { 
      Sheets: { 'Errores': worksheet }, 
      SheetNames: ['Errores'] 
    };

    const excelBuffer: any = XLSX.write(workbook, { 
      bookType: 'xlsx', 
      type: 'array' 
    });

    this.saveAsExcelFile(excelBuffer, fileName + '_Errores');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    
    saveAs(data, fileName + '_' + new Date().getTime() + '.xlsx');
  }
}